module.exports = __webpack_public_path__ + "img/005任莉莉.9cc0c954.jpg";